namespace TabAurous.Inventory {
    export namespace JobWorkConvertToWIPItemsService {
        export const baseUrl = 'Inventory/JobWorkConvertToWIPItems';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ConvertToWIPItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Inventory/JobWorkConvertToWIPItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkConvertToWIPItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
